import { getRadioSelectionParamTagItem } from './fabrics/radio_selection_param_tag';

export const AccessSystemTagItem = getRadioSelectionParamTagItem('Вход по пропускам', 'Свободный вход');
